import { graphql } from '@/generated/gql';

export const INTAKE_NUCLEAR_COMPLIANCE_FORM_QUERY = graphql(/* GraphQL */ `
  query IntakeNuclearComplianceForm($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        request {
          id
          complianceFormData
        }
      }
    }
  }
`);
